module.exports = __webpack_public_path__ + "img/section8.fe3ef270.png";